/**
 * @fileoverview GET handler for the "/engagement/messaging_services" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementMessagingServices } from "./constants";
import type { MessagingServicesResult, SubscriptionGroupChannelCode } from "./types";
import { isMessagingServicesResult } from "./validators";

export const getMessagingServices = reactQueryFetcherAdapter(
  engagementMessagingServices,
  (signal: AbortSignal, channel: SubscriptionGroupChannelCode, query: string): Promise<MessagingServicesResult> => {
    return fetch(
      `/engagement/messaging_services`,
      "GET",
      {
        channel,
        query,
      },
      { signal }
    );
  },
  isMessagingServicesResult
);
